export enum JobOfferActivityType {
    // Init
    PROPOSAL_CREATED = 'Proposal Created',
    PROPOSAL_UPDATED = 'Proposal Updated',
    /** Start date changed on an approved offer; does not restart the approval workflow. */
    START_DATE_UPDATED = 'Start Date Updated',

    // Approval
    SENT_FOR_APPROVAL = 'Sent for Approval',
    APPROVAL_NEXT_LEVEL = 'Approval Next Level',
    /** Recorded when an approver approves (may still be pending other approvers / levels). */
    APPROVAL_STEP_APPROVED = 'Approval Step Approved',
    /** Recorded when an approver rejects the offer. */
    APPROVAL_STEP_REJECTED = 'Approval Step Rejected',
    APPROVAL_COMPLETED = 'Approval Completed',

    // Send to Candidate
    OFFER_SENT = 'Offer Sent',
    REMINDER_SENT = 'Reminder Sent',

    // Response
    CANDIDATE_REJECTED = 'Candidate Rejected',
    CANDIDATE_ACCEPTED = 'Candidate Accepted',

    // Document Upload
    DOCUMENTS_REQUESTED = 'Documents Requested',
    DOCUMENTS_UPLOADED = 'Documents Uploaded',
}

export const DOCUMENT_REQUESTS_CONFIG = {
    REQUIRED_DOCUMENTS: [
        'Relieving and Experience Certificates',
        'Educational certificates',
        'Salary slips',
        'Photographs',
        'Date of Birth proof',
        'Pan Card',
        'Aadhar Card',
        'Address Proof',
    ],

    OPTIONAL_DOCUMENTS: ['Previous company Form-16 (non-mandatory)', 'Cancelled Cheque'],
}
